import React, { Component } from "react";
import PropTypes from "prop-types";
import "./PixelTemperature.css";

export default class PixelTemperature extends Component {

    tempValue = (pixelTemp, isCelcius, isCelciusImg)  => {

        if (isCelcius && isCelciusImg ) return pixelTemp + " \u00B0C"
    
       
        else return pixelTemp + " \u00B0F";

    }

  render() { 
      const { pixelTemp, isCelcius, isCelciusImg} = this.props;
      return (
          <div className="pixelTemp">
              {this.tempValue(pixelTemp, isCelcius, isCelciusImg)}
          </div> 
      
       );
  }
};



PixelTemperature.propTypes = {
    pixelTemp: PropTypes.number.isRequired,
};
